import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cd6233e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&id=6cd6233e&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=6cd6233e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6233e",
  null
  
)

export default component.exports